<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      :item="item"
      @hide="$emit('hide')"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
      @page-break="$emit('page-break')"
    />

    <!-- eslint-disable vue/no-v-html -->
    <div class="paragraph-container" v-html="value" />
    <!--eslint-enable-->
  </div>
</template>

<script>
import ElementControls from "@/components/form_fields/shared/element-controls.vue";
import commonStyles from "@/components/form_fields/shared/commonStyles";
import sharedActions from "@/components/form_fields/shared/sharedActions";

export default {
  name: "Paragraph",
  components: {
    ElementControls,
  },
  mixins: [commonStyles, sharedActions],
  props: {
    item: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      default: () => {
        return {};
      },
    },
    formId: {
      type: String,
      required: true,
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["hide", "delete", "duplicate", "page-break"],
  computed: {
    paragraphStyle() {
      return {
        color: this.styling.fontColor || "#000000",
        fontSize: `${this.itemStyling.fontSize}px` || "16px",
        fontFamily: this.styling.fontFamily || "sans-serif",
      };
    },
    value() {
      return this.replaceTagWithAnswer(this.item.value);
    },
  },
};
</script>

<style scope>
.paragraph-container img {
  display: block;
  max-width: 100%;
  width: fit-content;
  object-fit: cover;
}
.paragraph-container,
.paragraph-container p,
.paragraph-container p span {
  line-height: 150%;
  font-size: v-bind("paragraphStyle.fontSize");
  color: v-bind("paragraphStyle.color");
  font-family: v-bind("paragraphStyle.fontFamily");
}

.paragraph-container {
  overflow-wrap: break-word;
  margin: 8px 0;
}

.paragraph-container p + p {
  margin-top: var(--richtext-para-spacing);
  margin-bottom: 0;
}
</style>
